import React, { useState } from "react";
import LogoSection from "./logosection";
import MenuSection from "./menusection";
import MenuHamburger from "./menuhamburger";

function Navbar({ menus, onHandleClickMenu, selectedPage }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <nav className="navbar px-5  py-4 flex justify-between items-center shadow-costum-navbar bg-white">
      {/* Logo */}
      <div className="flex-shrink-0">
        <LogoSection onHandleClickMenu={onHandleClickMenu} menu={menus[0]} />
      </div>

      {/* Menu Items */}
      <MenuSection
        menus={menus}
        onHandleClickMenu={onHandleClickMenu}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        selectedPage={selectedPage}
      />

      {/* Hamburger Menu (Mobile) */}
      <MenuHamburger isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
    </nav>
  );
}

export default Navbar;